import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d0730bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "descriptionContainer" }
const _hoisted_2 = { class: "descriptionContainer__close" }
const _hoisted_3 = { class: "headerContainer" }
const _hoisted_4 = {
  key: 0,
  class: "projectSection"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "projectSection__title" }, "Nuevo Proyecto", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "projectSection__state" }, " Completa la información requerida para crear el nuevo proyecto. ", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "projectSection"
}
const _hoisted_9 = { class: "projectSection__title" }
const _hoisted_10 = { class: "projectSection__state" }
const _hoisted_11 = { class: "projectSection__progressBar" }
const _hoisted_12 = { class: "projectSection__state" }
const _hoisted_13 = { class: "projectSection__progressBar__progressText" }
const _hoisted_14 = { class: "projectSection__buttons" }
const _hoisted_15 = { class: "formContainer" }
const _hoisted_16 = { class: "form" }
const _hoisted_17 = { class: "form__formGroup--row" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "enterprise" }, "Empresa", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Seleccione", -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "form__formGroup" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nombre del proyecto", -1))
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "form__formGroup" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Descripción", -1))
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "form__formGroup" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "imgUrl" }, "Imagen de proyecto", -1))
const _hoisted_29 = { class: "form__formGroup--date" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startDate" }, "Fecha de Inicio", -1))
const _hoisted_31 = ["disabled"]
const _hoisted_32 = { class: "form__formGroup--date" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "endDate" }, "Fecha Fin", -1))
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "form__formGroup--row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "showState" }, "Estado", -1))
const _hoisted_37 = ["value", "disabled"]
const _hoisted_38 = { class: "form__formGroup--row" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "status" }, "Estado", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Elige un estado", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "todo" }, "Por hacer", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "progress" }, "En Progreso", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "done" }, "Hecho", -1))
const _hoisted_44 = [
  _hoisted_40,
  _hoisted_41,
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = { class: "form__formGroup--row" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "category" }, "Categoria", -1))
const _hoisted_47 = ["value", "disabled"]
const _hoisted_48 = { class: "form__formGroup--row" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "category" }, "Categoria", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Elige una categoria", -1))
const _hoisted_51 = ["value"]
const _hoisted_52 = { class: "form__formGroup--row" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "newCategory" }, "Nueva Categoria", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " add ", -1))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = { class: "form__formGroup" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Usuarios en el proyecto:", -1))
const _hoisted_58 = { class: "usersContainer" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_60 = { class: "form__formGroup--row" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "userPick" }, "Agregar Usuario", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Elige un usuario", -1))
const _hoisted_63 = ["value"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " person_add ", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "button" }, "Agregar usuario", -1))
const _hoisted_66 = [
  _hoisted_64,
  _hoisted_65
]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " add_task ", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "button" }, "Guardar", -1))
const _hoisted_69 = [
  _hoisted_67,
  _hoisted_68
]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " cancel ", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "button" }, "Cancelar", -1))
const _hoisted_72 = [
  _hoisted_70,
  _hoisted_71
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalCharging = _resolveComponent("ModalCharging")!
  const _component_UserProfilePicker = _resolveComponent("UserProfilePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ModalCharging, { open: _ctx.isLoading }, null, 8, ["open"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDescriptionContainer && _ctx.closeDescriptionContainer(...args))),
        class: "material-symbols-outlined"
      }, "cancel")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (_ctx.creatingProject)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.project.name), 1),
                _createElementVNode("span", _hoisted_10, "Estado: " + _toDisplayString(_ctx.translateState(_ctx.project.state)), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", {
                    style: _normalizeStyle(`width: ${_ctx.project.progress}%`)
                  }, null, 4)
                ]),
                _createElementVNode("span", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, " Progreso: " + _toDisplayString(_ctx.project.progress) + "% ", 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openProject && _ctx.openProject(...args))),
                    class: "projectSection__buttons__button projectSection__buttons__button--open"
                  }, " Abrir "),
                  (_ctx.isUserAdmin)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.editProject && _ctx.editProject(...args))),
                        class: "projectSection__buttons__button projectSection__buttons__button--edit"
                      }, " Editar "))
                    : _createCommentVNode("", true)
                ])
              ]))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("form", _hoisted_16, [
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("select", {
                id: "enterprise",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pickedEnterpriseFromAdmin) = $event)),
                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.enterpriseChanged && _ctx.enterpriseChanged(...args)))
              }, [
                _hoisted_19,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enterprises, (enterprise) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: enterprise.enterprise_id,
                    key: enterprise.enterprise_id
                  }, _toDisplayString(enterprise.name), 9, _hoisted_20))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.pickedEnterpriseFromAdmin]
              ])
            ], 512), [
              [_vShow, _ctx.editSessionOn && _ctx.creatingProject]
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "name",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.project.name) = $event)),
            disabled: _ctx.disableInput,
            placeholder: "Nombre"
          }, null, 8, _hoisted_23), [
            [_vModelText, _ctx.project.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _withDirectives(_createElementVNode("textarea", {
            class: "projectForm__descArea",
            cols: "30",
            rows: "10",
            placeholder: "Descripción de proyecto",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.project.description) = $event)),
            disabled: _ctx.disableInput
          }, "\n          ", 8, _hoisted_26), [
            [_vModelText, _ctx.project.description]
          ])
        ]),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("input", {
                type: "file",
                onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.prepareFile && _ctx.prepareFile(...args))),
                multiple: ""
              }, null, 32)
            ], 512), [
              [_vShow, _ctx.editSessionOn]
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _withDirectives(_createElementVNode("input", {
            type: "date",
            id: "startDate",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.project.startDate) = $event)),
            disabled: _ctx.disableInput
          }, null, 8, _hoisted_31), [
            [_vModelText, _ctx.project.startDate]
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _withDirectives(_createElementVNode("input", {
            type: "date",
            id: "endDate",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.project.endDate) = $event)),
            disabled: _ctx.disableInput
          }, null, 8, _hoisted_34), [
            [_vModelText, _ctx.project.endDate]
          ])
        ]),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("input", {
                type: "text",
                id: "showState",
                value: _ctx.translateState(_ctx.project.state),
                disabled: _ctx.disableInput
              }, null, 8, _hoisted_37)
            ], 512), [
              [_vShow, !_ctx.editSessionOn]
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _withDirectives(_createElementVNode("select", {
                id: "status",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.project.state) = $event)),
                placeholder: "Elige un estado"
              }, _hoisted_44, 512), [
                [_vModelSelect, _ctx.project.state]
              ])
            ], 512), [
              [_vShow, _ctx.editSessionOn]
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_45, [
              _hoisted_46,
              _createElementVNode("input", {
                type: "text",
                id: "category",
                value: _ctx.getCategoryName(_ctx.project.category_id),
                disabled: _ctx.disableInput
              }, null, 8, _hoisted_47)
            ], 512), [
              [_vShow, !_ctx.editSessionOn]
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_48, [
              _hoisted_49,
              _withDirectives(_createElementVNode("select", {
                id: "category",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.project.category_id) = $event)),
                placeholder: "Elige una categoria"
              }, [
                _hoisted_50,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: category.category_id,
                    key: category.category_id
                  }, _toDisplayString(category.name), 9, _hoisted_51))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.project.category_id]
              ])
            ], 512), [
              [_vShow, _ctx.editSessionOn]
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "newCategory",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newCategory) = $event))
              }, null, 512), [
                [_vModelText, _ctx.newCategory]
              ])
            ], 512), [
              [_vShow, _ctx.editSessionOn]
            ])
          ]),
          _: 1
        }),
        _withDirectives(_createElementVNode("div", {
          class: "form__button form__button--addUserButton",
          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.addNewCategory && _ctx.addNewCategory(...args)))
        }, _hoisted_55, 512), [
          [_vShow, _ctx.editSessionOn]
        ]),
        _createElementVNode("div", _hoisted_56, [
          _hoisted_57,
          _createElementVNode("div", _hoisted_58, [
            _withDirectives(_createElementVNode("div", null, "Agrega usuarios al proyecto.", 512), [
              [_vShow, _ctx.users.length < 1 && !_ctx.editSessionOn]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
              return (_openBlock(), _createElementBlock("div", {
                key: user.id
              }, [
                _createVNode(_component_UserProfilePicker, {
                  user: user,
                  editing: _ctx.editSessionOn,
                  onRemoveUserFrom: ($event: any) => (_ctx.removeUserFromProject(user.id))
                }, null, 8, ["user", "editing", "onRemoveUserFrom"])
              ]))
            }), 128))
          ]),
          _hoisted_59,
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_60, [
                _hoisted_61,
                _withDirectives(_createElementVNode("select", {
                  id: "userPick",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.pickedUserToAdd) = $event)),
                  placeholder: "Elige un estado"
                }, [
                  _hoisted_62,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersFromEnterprise, (user) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: user.user_id,
                      key: user.user_id
                    }, _toDisplayString(user.first_name +' '+ user.last_name), 9, _hoisted_63))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.pickedUserToAdd]
                ])
              ], 512), [
                [_vShow, _ctx.editSessionOn]
              ])
            ]),
            _: 1
          }),
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", {
                class: "form__button form__button--addUserButton",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.addUserToProject && _ctx.addUserToProject(...args)))
              }, _hoisted_66, 512), [
                [_vShow, _ctx.editSessionOn]
              ])
            ]),
            _: 1
          })
        ]),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", {
              class: "form__button form__button--saveButton",
              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.saveProject && _ctx.saveProject(...args)))
            }, _hoisted_69, 512), [
              [_vShow, _ctx.editSessionOn]
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", {
              class: "form__button form__button--cancelButton",
              onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.cancelEdition && _ctx.cancelEdition(...args)))
            }, _hoisted_72, 512), [
              [_vShow, _ctx.editSessionOn]
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}